import React from 'react';
import './EmptyState.css';

export interface EmptyStateProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Title text */
  title: string;
  /** Optional description text */
  description?: string;
  /** Optional icon displayed above the title */
  icon?: React.ReactNode;
  /** Optional action element (button or link) */
  action?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  icon,
  action,
  className = '',
  ...rest
}) => {
  const classes = ['hi-ui-empty-state', className].filter(Boolean).join(' ');

  return (
    <div className={classes} {...rest}>
      {icon && (
        <div className="hi-ui-empty-state__icon" aria-hidden="true">
          {icon}
        </div>
      )}
      <h3 className="hi-ui-empty-state__title">{title}</h3>
      {description && <p className="hi-ui-empty-state__description">{description}</p>}
      {action && <div className="hi-ui-empty-state__action">{action}</div>}
    </div>
  );
};
